import {
  drugtransaction_checkout_to_retail_order_create,
  drugtransaction_checkout_read,
  drugtransaction_checkout_partial_update,
  drugtransaction_carts_active_documentation_document_create,
  drugtransaction_carts_active_documentation_document_delete,
} from "@/lib/api-client.js";
import { getAxiosConfig as axconf } from "@/lib/api-config.js";
// import get from "lodash/get";

import Vue from "vue";

export default {
  namespaced: true,
  state: {
    by_pharmacy_transaction: undefined,
    finished_transactions: [],
    delivery_address: undefined,
    purchase_options: {},
    deliveryCarriers: [],
    global_amount: undefined,
    global_items: undefined,
    checkout_by_pharmacy: undefined,
    documentation: undefined,
    notify: 0, // it's a timestamp, so I don't need to clear the field
  },
  actions: {
    REQUEST_CHECKOUT: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        drugtransaction_checkout_read({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
          checkoutUuid: payload.checkout_uuid,
        }).then(
          response => {
            var checkout = response.data;
            commit("MUTATE_DELIVERY_ADDRESS", checkout.delivery_address);
            commit("MUTATE_GLOBAL_AMOUNT", checkout.amount);
            commit("MUTATE_GLOBAL_ITEMS", checkout.item_list);
            commit("MUTATE_BY_PHARMACY", checkout.by_pharmacy);
            commit("MUTATE_DOCUMENTATION", response.data.documentation);
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_UPDATE_CHECKOUT: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        drugtransaction_checkout_partial_update({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
          checkoutUuid: payload.checkout_uuid,
          data: payload.data,
        }).then(
          response => {
            var checkout = response.data;
            commit("MUTATE_DELIVERY_ADDRESS", checkout.delivery_address);
            commit("MUTATE_GLOBAL_AMOUNT", checkout.amount);
            commit("MUTATE_GLOBAL_ITEMS", checkout.item_list);
            commit("MUTATE_BY_PHARMACY", checkout.by_pharmacy);
            commit("MUTATE_DOCUMENTATION", response.data.documentation);
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    CHECKOUT_TO_RETAIL_ORDER: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        drugtransaction_checkout_to_retail_order_create({
          data: payload.data,
          checkoutUuid: payload.checkout_uuid,
          role: "vooyguest",
          roleUuid: "1",
          $config: axconf(),
        }).then(
          response => {
            commit("MUTATE_ADD_FINISHED_TRANSACTION", response.data);
            // Quitamos los productos pagados del carrito
            response.data.order.item_list.drugs.forEach(drug => {
              commit("shoppingcart/MUTATE_REMOVE_PRODUCT", {
                price_uuid: drug.price.parent,
              }, { root: true });
            });
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    SEND_CART_DOCUMENT: ({ commit }, payload) => {
      let extraconf = {};
      if (payload.onUploadProgress) {
        extraconf["onUploadProgress"] = payload.onUploadProgress;
      }
      return new Promise((resolve, reject) => {
        drugtransaction_carts_active_documentation_document_create({
          $config: axconf(extraconf),
          role: "vooyguest",
          roleUuid: "1",
          data: payload.data,
        }).then(
          response => {
            commit("MUTATE_ADD_CART_UPLOADED_FILES", response.data)
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    DELETE_CART_DOCUMENT: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        drugtransaction_carts_active_documentation_document_delete({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
          documentUuid: payload.document_uuid,

        }).then(
          response => {
            commit(
              "MUTATE_DELETE_CART_UPLOADED_FILES",
              payload.document_uuid
            );
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
  },
  mutations: {
    MUTATE_DELETE_CART_UPLOADED_FILES: (state, document_uuid) => {
      var current_documentation = state.documentation;
      const filtered_files = current_documentation.documents.filter(document => document.uuid != document_uuid);
      current_documentation.documents = filtered_files;
      state.documentation = Object.assign({}, current_documentation);
    },
    MUTATE_ADD_CART_UPLOADED_FILES: (state, file_data) => {
      var current_documentation = state.documentation;
      current_documentation.documents.push(file_data);
      state.documentation = Object.assign({}, current_documentation);
    },
    MUTATE_PURCHASE_OPTIONS: (state, payload) => {
      var purchase_options = state.purchase_options;
      if (!purchase_options) {
        purchase_options = {};
        purchase_options[payload.delivery_address_uuid] = payload.options;
        Vue.set(state, "purchase_options", purchase_options);
        return;
      }
      state.purchase_options[payload.delivery_address_uuid] = payload.options;
    },
    MUTATE_DELIVERY_ADDRESS: (state, payload) => {
      Vue.set(state, "delivery_address", payload);
    },
    MUTATE_GLOBAL_AMOUNT: (state, payload) => {
      state.global_amount = Object.assign({}, payload);
    },
    MUTATE_GLOBAL_ITEMS: (state, payload) => {
      if (!payload) {
        return;
      }
      if (!payload.drugs) {
        state.global_items = [];
        return;
      }
      state.global_items = payload.drugs;
    },
    MUTATE_BY_PHARMACY: (state, payload) => {
      state.checkout_by_pharmacy = payload;
    },
    MUTATE_ADD_FINISHED_TRANSACTION: (state, payload) => {
      state.finished_transactions.push(
        Object.assign({}, payload.order, { organization: payload.organization })
      );
    },
    MUTATE_DOCUMENTATION: (state, payload) => {
      state.documentation = Object.assign({}, payload);
    },
  },
  getters: {
    getDocumentsByOrganizationUUID: state => organization_uuid => {
      if (!state.documentation || !state.documentation.documents) {
        return undefined;
      }
      const found_files = state.documentation.documents.filter(document => document.dest_organization == organization_uuid);
      return found_files;
    },
  },
};
